'use client';

import React, { useState } from 'react';
import AccordionItem from './AccordionItem';
import styles from './SupportFAQ.module.css';

const faqData = [
    {
        question: 'Как заключить договор с СДЭК?',
        answer: 'Чтобы заключить договор, необходимо предоставить пакет документов. Для юридических лиц это..., для ИП - ... . Процесс можно начать онлайн через наш личный кабинет.',
    },
    {
        question: 'Какие условия для физических лиц?',
        answer: 'Физические лица могут отправлять посылки без заключения договора, используя наши пункты выдачи или вызвав курьера. Доступны различные тарифы в зависимости от веса и направления.',
    },
    {
        question: 'Как согласовать дату доставки?',
        answer: 'Дату и время доставки можно изменить в личном кабинете на сайте или в мобильном приложении. Также вы можете связаться с курьером по номеру, который придет в SMS-уведомлении.',
    },
    {
        question: 'Какие способы оплаты доступны?',
        answer: 'Мы принимаем оплату наличными, банковскими картами при получении, а также онлайн-оплату на сайте при оформлении заказа.',
    },
    {
        question: 'Как отследить посылку?',
        answer: 'Отследить посылку можно на главной странице нашего сайта или в мобильном приложении по трек-номеру, который вы получили при отправке.',
    },
    {
        question: 'Что делать, если посылка повреждена?',
        answer: 'В случае повреждения посылки необходимо составить акт в пункте выдачи или при курьере. После этого обратитесь в службу поддержки с заявлением на компенсацию.',
    },
];

export const FaqAccordion = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const handleAccordionClick = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className={styles.faqGrid}>
            {faqData.map((item, index) => (
                <AccordionItem
                    key={index}
                    question={item.question}
                    answer={item.answer}
                    isOpen={openIndex === index}
                    onClick={() => handleAccordionClick(index)}
                />
            ))}
        </div>
    );
};
